import * as React from 'react';
import { Text } from '@grandvisionhq/elements';
import { useLink } from '@grandvisionhq/frk-routing';
import { useIntl, useFeatureToggles } from '@grandvisionhq/state';
import OrderListItem from './OrderListItem.js';
import { logOrderEvent } from '../../../data-layer/orders.js';
import { makeOrderDetailsClickEvent } from '../../../data-layer/utils.js';

const OrderListItemContainer = ({ lineItems , orderDate , orderNumber , paymentStatus , orderStatus , shipmentStatus , showOrderDate =true ,  })=>{
    const { dateTime , getLabel  } = useIntl();
    var ref;
    const { href , onClick  } = (ref = useLink({
        route: 'me.orders.detail',
        params: {
            orderId: orderNumber
        }
    })) !== null && ref !== void 0 ? ref : {};
    const { isOrderWorkflowStatusEnabled =false  } = useFeatureToggles() // default to false until feature toggle is enabled for particular opco
    ;
    const labels = {
        order: getLabel('common.order'),
        viewDetails: getLabel('account.common.viewDetails')
    };
    const handleOnClick = (e)=>{
        logOrderEvent(makeOrderDetailsClickEvent('my_online_orders', orderNumber, paymentStatus));
        onClick === null || onClick === void 0 ? void 0 : onClick(e);
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: "order-list-item",
        key: orderNumber
    }, /*#__PURE__*/ React.createElement("div", {
        className: "order-list-item__header"
    }, /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Text, {
        className: "order-list-item__order-number",
        variant: "body-head"
    }, labels.order, " ", orderNumber), isOrderWorkflowStatusEnabled && orderStatus ? /*#__PURE__*/ React.createElement("div", {
        className: "order-list-item__order-status"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, getLabel('account.order.shipmentState.label'), ":", /*#__PURE__*/ React.createElement(Text, {
        className: "order-list-item__status-detail__text",
        variant: "list"
    }, orderStatus))) : shipmentStatus && /*#__PURE__*/ React.createElement("div", {
        className: "order-header__shipment"
    }, /*#__PURE__*/ React.createElement(Text, {
        variant: "body-head"
    }, getLabel('account.order.shipmentState.label'), ":", /*#__PURE__*/ React.createElement(Text, {
        className: "order-header__status-detail__text",
        variant: "list"
    }, shipmentStatus)))), showOrderDate && /*#__PURE__*/ React.createElement(Text, {
        variant: "list",
        color: "text-secondary"
    }, dateTime.formatShortDate(orderDate))), lineItems.map((lineItem)=>/*#__PURE__*/ React.createElement(OrderListItem, {
            key: `${lineItem.title}-${lineItem.subtitle}`,
            header: lineItem.title,
            subtitle: lineItem.subtitle,
            imageUrl: lineItem.imageUrl,
            href: href,
            onClick: handleOnClick,
            labels: labels
        })
    ));
};
var OrderListItemContainer$1 = OrderListItemContainer;

export { OrderListItemContainer$1 as default };
//# sourceMappingURL=OrderListItemContainer.js.map
